export class GridFilterUtils {
    static saveFilters = (gridStateRef: any, reportType: string): void => {
        if (!gridStateRef?.current) {
            console.warn('Grid State reference not available');
            return;
        }
        try {
            const state = gridStateRef.current.getStateAsString([]);
            const gridData = JSON.parse(state);
            const storageKey = `grid_filters_${reportType}`;
            if (gridData) {
                localStorage.setItem(storageKey, JSON.stringify(gridData));
            }
        } catch (error) {
            console.error('Error saving filters to storage:', error);
        }
    }

    static loadFiltersFromStorage = (reportType: string) => {
        const storageKey = `grid_filters_${reportType}`;
        const savedFilters = localStorage.getItem(storageKey);

        if (savedFilters) {
            try {
                const parsedFilters = savedFilters;
                return parsedFilters;
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                // Clear invalid data
                localStorage.removeItem(storageKey);
            }
        }
        return null;
    }

    static applyFiltersToGrid = (gridStateRef: any, filters: any, delay: number = 100): void => {
        if (!gridStateRef?.current || !filters) {
            console.warn('Grid state reference or filters not available');
            return;
        }

        setTimeout(() => {
            try {
                const currentState = gridStateRef.current.getStateAsString([]);
                const currentGridData = JSON.parse(currentState);
                currentGridData.filtering = filters;

                gridStateRef.current.applyState(JSON.stringify(currentGridData), []);
            } catch (error) {
                console.error('Error applying filters', error);
            }
        }, delay);
    }

    static clearSavedFilters = (reportType: string): void => {
        const storageKey = `grid_filters_${reportType}`;
        localStorage.removeItem(storageKey);
    }

    static clearAllFilters = (gridRef: any, reportType: string): void => {
        if (gridRef?.current) {
            gridRef.current.clearFilter();
        }
        GridFilterUtils.clearSavedFilters(reportType);
    }

    static getCurrentFilterState = (gridStateRef: any): any | null => {
        if (!gridStateRef?.current) {
            return null;
        }

        try {
            const state = gridStateRef.current.getStateAsString([]);
            const gridData = JSON.parse(state);
            return gridData.filtering || null;
        } catch (error) {
            console.error('Error getting current filter state:', error);
            return null;
        }
    }

    static restorGridStatae = (gridStateRef: any, reportType: string) => {
        const savedFilters = GridFilterUtils.loadFiltersFromStorage(reportType);
        if (savedFilters) {
            try {
                gridStateRef.current.applyStateFromString(savedFilters, [])
            } catch (err) {
                console.error(err);
            }
        }
    }
}